import React from 'react'
import { Box } from '@mui/material'
import AHUSelectionForm from './components/forms/AHUSelectionForm'
import { UnifiedStateProvider } from './context/UnifiedStateContext'

function App() {
  return (
    <UnifiedStateProvider>
      <Box sx={{ width: '100%', height: '100vh', bgcolor: '#f5f5f5' }}>
        <AHUSelectionForm />
      </Box>
    </UnifiedStateProvider>
  )
}

export default App